package com.klantenstop.web.pages.authentication.registration

import com.klantenstop.web.components.form.RegisterFormData
import com.klantenstop.web.utils.MVI

interface RegistrationContract : MVI<RegistrationContract.State, RegistrationContract.Intent, RegistrationContract.Effect> {
    data class State(
        val formData: RegisterFormData? = null,
        val showValidation: Boolean = false
    )

    sealed class Intent {
        data object Registration : Intent()
        data class UpdateFormData(val formData: RegisterFormData): Intent()
    }

    sealed class Effect {
        data object NavigateToNextScreen : Effect()
    }
}
